/**
 * dayjs是一个格式化时间的插件，用于获取相对时间
 */
import Vue from 'vue'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import relativeTime from 'dayjs/plugin/relativeTime';

//配置中文语言包
dayjs.locale('zh-cn');
//配置使用处理相对时间
dayjs.extend(relativeTime);

//把处理相对时间的代码包装为全局过滤器
Vue.filter('relativeTime',value =>{
    return dayjs(value).from(dayjs())
});
